import React, {FC, useState} from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {OkCancelDialog} from '../../../common/dialogs/okCancelDialog';
import {SideFrameDialogMessage} from './sideFrameDialogMessage';
import {SideFrameDialogDefinition} from './sideFrameDialogsHooks';

/*
 * Props.
 */

interface SideFrameConfirmProps {
  confirmData: ConfirmDefinition;
  onOkClick: Handler;
  onCancelClick: Handler;
}

/*
 * Component.
 */

const SideFrameConfirm: FC<SideFrameConfirmProps> = ({confirmData, onOkClick, onCancelClick}) => {
  const {title, message, okTitle, cancelTitle} = confirmData;
  return (
    <OkCancelDialog
      title={title}
      okButtonLabel={okTitle}
      cancelButtonLabel={cancelTitle}
      onOkClick={onOkClick}
      onRequestClose={onCancelClick}
    >
      <SideFrameDialogMessage>{message}</SideFrameDialogMessage>
    </OkCancelDialog>
  );
};

/*
 * Hook.
 */

interface ConfirmDefinition extends SideFrameDialogDefinition {
  title: string;
  message: string;
  okTitle: string | null;
  cancelTitle: string | null;
}

export function useSideFrameConfirm() {
  const [confirmData, setConfirmData] = useState<ConfirmDefinition | null>(null);
  if (!confirmData) {
    return {
      setConfirmData,
      confirm: null,
    };
  }

  function onConfirmClick(confirm: boolean) {
    if (!confirmData) {
      return;
    }

    confirmData.onDone(confirm);
    setConfirmData(null);
  }

  return {
    setConfirmData,
    confirm: (
      <SideFrameConfirm
        confirmData={confirmData}
        onOkClick={() => onConfirmClick(true)}
        onCancelClick={() => onConfirmClick(false)}
      />
    ),
  };
}
